import React, { Component } from 'react';

class ECommerce extends Component {
    render() {
        return (
            <div className="App">
            <a href="https://billy-bass-pro-shop.herokuapp.com/" target="_blank">
              <h2>Billy Bass Pro Shop</h2>
            </a>
            <h4>
              JavaScript | React | Node.js | Express.js | Redux | PostgreSql | Material UI
            </h4>
            <h5>E-commerce app</h5>
            <h5>
              created parallel logged in and guest user experiences that allows a user to add items to cart as guest and then log in to check out with those items
            </h5>
            <h5>
              checkout with Stripe API integration
            </h5>
          </div>
            )}
}
export default ECommerce